var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative flex items-end" }, [
    _c("img", {
      staticClass: "mr-4",
      attrs: { src: "/static/img/mascot/z.png", alt: "Tood", width: "70px" }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bubble px-4 py-2 leading-normal" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fc78bb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc78bb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/Bubble.vue
// module id = 648
// module chunks = 1